import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api",
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
  },
});

export const setToken = (token) => {
  console.log("token det:", token);
  if (token) {
    instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete instance.defaults.headers.common["Authorization"];
  }
};

const responseBody = (response) => response.data;

// const requests = {
//   get: (url, body) => instance.get(url, body).then(responseBody),
//   post: (url, body, headers) =>
//     instance.post(url, body, headers).then(responseBody),
//   imagepost: (url, body, headers) =>
//     instance.post(url, body, {headers}).then(responseBody),
//   put: (url, body) => instance.put(url, body).then(responseBody),
// };

// export default requests;

// Function to get user IP
// Function to get Public IPv4 Address
const getUserIP = async () => {
  try {
    const res = await axios.get("https://api4.ipify.org?format=json"); // Force IPv4
    return res.data.ip;
  } catch (error) {
    console.error("Error fetching public IP:", error);
    return "0.0.0.0"; // Default fallback
  }
};
// Modify requests to include IP in the body
const requests = {
  get: async (url, body = {}) => {
    const ipaddress = await getUserIP();
    return instance.get(url, { ...body, ipaddress }).then(responseBody);
  },
  post: async (url, body = {}, headers = {}) => {
    const ipaddress = await getUserIP();
    return instance
      .post(url, { ...body, ipaddress }, headers)
      .then(responseBody);
  },
  imagepost: async (url, body = {}, headers = {}) => {
    const ipaddress = await getUserIP();
    return instance
      .post(url, { ...body, ipaddress }, { headers })
      .then(responseBody);
  },
  put: async (url, body = {}) => {
    const ipaddress = await getUserIP();
    return instance.put(url, { ...body, ipaddress }).then(responseBody);
  },
  delete: async (url) => {
    const ipaddress = await getUserIP();
    return instance.delete(url, { ipaddress }).then(responseBody);
  },
};

export default requests;
